// Same as TriState in Visual Basic
export enum TriState {
    UseDefault = -2, // 0xFFFFFFFE
    True = -1, // 0xFFFFFFFF
    False = 0
}

export enum UserRole {
    None = 0,
    SuperAdmin = 1,
    Admin = 2,
    Basic = 3,
    NonEquator = 4,
    Client = 5
}

export enum UserStatus {
    None = 0,
    RegistrationRequest = 1,
    ActivationEmailSent = 2,
    Active = 3,
    Deleted = 4
}

export enum LookupGroup {
    All = 0,
    Departments = 1,
    Locations = 2
}

export enum SignInView {
    SignIn = 1,
    FogottenPassword = 2,
    Register = 3
}

export enum AssetStatus {
    New = 1,
    Updated = 2,
    Active = 3,
    MarkedForDeletion = 4,
    Archived = 5
}

export enum AssetFileStatus {
    Active = 1,
    MarkedForDeletion = 2,
    Archived = 3
}

export enum ObjType {
    Asset = 1,
    File = 2
}

export enum HistoryType {
    None = 0,
    Created = 1,
    Updated = 2,
    MarkedForDeletion = 3,
    MarkForDeletionOverridden = 4,
    Archived = 5,
    Restored = 6,
    IssueLogged = 7,
    IssueDeleted = 8,
    FileAdded = 9,
    FileUpdated = 10,
    FileDeleted = 11,
    FileMarkedForDeletion = 12,
    FileMarkForDeletionOverridden = 13,
    FileIssueLogged = 14,
    FileIssueDeleted = 15,
    NoteAdded = 16,
    NoteUpdated = 17,
    NoteDeleted = 18,
    FileArchived = 19,
    FileRestored = 20,
    LinkUpdated = 21,
    LinkDeleted = 22
}

export enum HistoryDialogType {
    AssetHistory = 1,
    UserDownloadHistory = 2,
    FileDownloadHistory = 3
}